import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const approveReturn = createAsyncThunk("approveReturn", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`returns/approval/${id}`, data);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while approving return");
	}
});

const ReturnApproveSlice = createSlice({
	name: "ReturnApproveSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(approveReturn.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(approveReturn.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(approveReturn.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default ReturnApproveSlice.reducer;
